<div
  class="modal-overlay"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'prepaid-modal-title'"
  tabindex="0"
  (click)="onOverlayClick($event)"
  (keydown.escape)="closeModal()"
>
  <div class="modal-container">
    <div class="modal-header">
      <h2 class="modal-title" id="prepaid-modal-title">{{ modalTitle }}</h2>
      <button type="button" class="close-button" (click)="closeModal()" aria-label="Close">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <form [formGroup]="prepaidForm" (ngSubmit)="onSubmit()" class="add-prepaid-modal__form">
      <div class="modal-body">
        <div class="form-row">
          <div class="form-group">
            <label for="prepaidPackageName"
              >Prepaid Package Name<span class="required">*</span></label
            >
            <input
              type="text"
              id="prepaidPackageName"
              placeholder="e.g. Buy 2 Single Washes, Get 1 Single Wash"
              formControlName="prepaid_package_name"
            />
            @if (showError('prepaid_package_name')) {
              <div class="error-message">
                <span>Prepaid package name is required</span>
              </div>
            }
          </div>
          <div class="form-group status-group">
            <span class="form-group__label">Status</span>
            <div class="status-toggle">
              <label class="switch">
                <input
                  type="checkbox"
                  id="packageStatusToggle"
                  formControlName="package_status"
                  aria-label="Package active status"
                />
                <span class="slider round"></span>
              </label>
              <span>Active</span>
            </div>
          </div>
        </div>

        <div formArrayName="items">
          @for (_wash of items.controls; track $index; let i = $index) {
            <section class="prepaid-wash-section" [formGroupName]="i">
              @if (isWashSectionCollapsible(i)) {
                <button
                  type="button"
                  class="prepaid-wash-section__toggle"
                  (click)="toggleWashSection(i)"
                  [attr.aria-expanded]="isWashSectionExpanded(i)"
                >
                  <h3 class="prepaid-wash-section__title">{{ getWashSectionLabel(i) }}</h3>
                  <svg
                    class="prepaid-wash-section__chevron"
                    [class.prepaid-wash-section__chevron--expanded]="isWashSectionExpanded(i)"
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="#555963"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              } @else {
                <h3 class="prepaid-wash-section__title prepaid-wash-section__title--static">
                  {{ getWashSectionLabel(i) }}
                </h3>
              }

              @if (!isWashSectionCollapsible(i) || isWashSectionExpanded(i)) {
                <div class="prepaid-wash-section__content">
                  <div class="form-row">
                    <div class="form-group">
                      <label [for]="getWashTypeInputId(i)">
                        Wash Type
                        @if (isWashItemRequired(i)) {
                          <span class="required">*</span>
                        }
                      </label>
                      <mat-select
                        [id]="getWashTypeInputId(i)"
                        formControlName="wash_type"
                        placeholder="Select wash type"
                        class="form-select"
                      >
                        @for (option of washTypeOptions; track option.value) {
                          <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                      </mat-select>
                      @if (showWashError(i, 'wash_type')) {
                        <div class="error-message"><span>Wash type is required</span></div>
                      }
                    </div>
                    <div class="form-group">
                      <label [for]="getWashNameInputId(i)">
                        {{ getWashNameFieldLabel(i) }}
                        @if (isWashItemRequired(i)) {
                          <span class="required">*</span>
                        }
                      </label>
                      <mat-select
                        [id]="getWashNameInputId(i)"
                        formControlName="wash_name"
                        [placeholder]="isWashNamesLoading(i) ? 'Loading...' : 'Select wash name'"
                        [attr.aria-busy]="isWashNamesLoading(i)"
                        [disabled]="isWashNameSelectDisabled(i)"
                        panelClass="prepaid-wash-name-panel"
                        class="form-select"
                      >
                        @for (option of washNameOptions(i); track option.value) {
                          <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                      </mat-select>
                      @if (showWashError(i, 'wash_name')) {
                        <div class="error-message">
                          <span>{{ getWashNameRequiredErrorMessage(i) }}</span>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label [for]="getWashCountInputId(i)">
                        Number of Washes
                        @if (isWashItemRequired(i)) {
                          <span class="required">*</span>
                        }
                      </label>
                      <input
                        type="number"
                        [id]="getWashCountInputId(i)"
                        placeholder="eg : 2"
                        formControlName="number_of_washes"
                        min="1"
                      />
                      @if (showWashError(i, 'number_of_washes')) {
                        <div class="error-message"><span>Number of washes is required</span></div>
                      }
                    </div>
                    <div class="form-group">
                      <label [for]="getWashPriceInputId(i)">
                        {{ getWashPriceFieldLabel(i) }}
                        @if (isWashItemRequired(i)) {
                          <span class="required">*</span>
                        }
                      </label>
                      <input
                        type="number"
                        [id]="getWashPriceInputId(i)"
                        [placeholder]="getWashPricePlaceholder(i)"
                        formControlName="wash_price"
                        [readonly]="!isWashPriceEditable(i)"
                        [class.input-readonly]="!isWashPriceEditable(i)"
                        min="0"
                        step="0.01"
                      />
                      @if (showWashError(i, 'wash_price')) {
                        <div class="error-message"><span>Wash price is required</span></div>
                      }
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label [for]="getWashTotalInputId(i)">{{ getWashTotalFieldLabel(i) }}</label>
                      <input
                        type="text"
                        [id]="getWashTotalInputId(i)"
                        class="input-readonly"
                        formControlName="wash_total"
                        placeholder="e.g. $10"
                        readonly
                      />
                    </div>
                    <div class="form-group">
                      <label [for]="getWashExpiryInputId(i)">
                        Expiry (months)
                        @if (isWashItemRequired(i)) {
                          <span class="required">*</span>
                        }
                      </label>
                      <input
                        type="number"
                        [id]="getWashExpiryInputId(i)"
                        placeholder="eg : 2"
                        formControlName="expiry_months"
                        min="1"
                      />
                      @if (showWashError(i, 'expiry_months')) {
                        <div class="error-message"><span>Expiry is required</span></div>
                      }
                    </div>
                  </div>
                  @if (showOptionalWashSectionError(i)) {
                    <div class="error-message">
                      <span>Complete all {{ getWashSectionLabel(i) }} fields or clear them</span>
                    </div>
                  }
                </div>
              }
            </section>
          }
        </div>

        <section class="pricing-options">
          <h3 class="pricing-options__title">Pricing Options</h3>
          <div class="form-row">
            <div class="form-group">
              <label for="totalWashPrice">Total Wash Price</label>
              <input
                type="text"
                id="totalWashPrice"
                class="input-readonly"
                formControlName="total_wash_price"
                placeholder="$0"
                readonly
              />
            </div>
            <div class="form-group">
              <label for="sellingPrice">Selling Price<span class="required">*</span></label>
              <input
                type="number"
                id="sellingPrice"
                placeholder="$0"
                formControlName="selling_price"
                min="0"
                step="0.01"
              />
              @if (showError('selling_price')) {
                <div class="error-message"><span>Selling price is required</span></div>
              }
            </div>
          </div>
        </section>

        <div class="form-group">
          <app-theme-color-picker formControlName="theme_color"></app-theme-color-picker>
        </div>

        <section class="prepaid-notes">
          <h3 class="prepaid-notes__title">Notes for Attendant</h3>
          <ul class="prepaid-notes__list">
            <li>Wash price = configured wash price of the selected package × number of washes</li>
            <li>
              If the wash price is custom, the admin must add the wash price for each item being
              sold
            </li>
            <li>Total wash price = sum of all configured wash line totals</li>
          </ul>
        </section>
      </div>

      <app-modal-footer-actions
        footerClass="modal-footer"
        secondaryText="Clear"
        primaryText="Save"
        primaryButtonType="submit"
        [primaryDisabled]="isSubmitting || (prepaidForm.invalid && submitted)"
        (secondaryClick)="clearForm()"
        (cancelClick)="closeModal()"
      />
    </form>
  </div>
</div>
